export default __webpack_public_path__ + "static/media/hapicolibri.a4f9876e.jpg";